import { BaseClient } from '@/api'

export class PermissionClient extends BaseClient {
  constructor(
  ) {
    super('permissions')
  }
}
